<template>
  <div class="info-tile info-tile-container">
    <h1 class="info-tile__title">
      <slot name="title" />
    </h1>
    <p class="info-tile__text">
      <slot name="text" />
    </p>
  </div>
</template>

<style lang="scss">
.info-tile-container {
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;

  .info-tile {
    &__title {
      margin-bottom: 6px;
      color: rgb(var(--v-theme-text-primary));
      font-size: var(--font-size-xxl);
    }

    &__text {
      color: rgb(var(--v-theme-text-secondary));
    }
  }
}
</style>
